import { Link, NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "@/hooks/useAuth";
import BrandMark from "@/components/BrandMark/BrandMark";
import "@/components/SiteHeader/SiteHeader.scss";

function SiteHeader() {
  const { t } = useTranslation();
  const { session, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    navigate("/");
  };

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand">
          <BrandMark />
        </Link>

        <nav className="site-header__nav">
          <NavLink to="/" end className="site-header__link">
            {t("header.explore")}
          </NavLink>
          {session ? (
            <>
              <NavLink to="/trips" className="site-header__link">
                {t("header.trips")}
              </NavLink>
              <span className="site-header__account" title={session.email}>
                {session.email.charAt(0).toUpperCase()}
              </span>
              <button
                type="button"
                className="site-header__button"
                onClick={handleSignOut}
              >
                {t("header.signOut")}
              </button>
            </>
          ) : (
            <>
              <NavLink to="/signin" className="site-header__link">
                {t("header.signIn")}
              </NavLink>
              <NavLink to="/signup" className="site-header__cta">
                {t("header.signUp")}
              </NavLink>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export default SiteHeader;
